<template>
	<div>
		<HeadIndex :info="true"></HeadIndex>
		<el-row>
			<el-col :span="6" :offset="4" class="logo_m">
				<!--<div class="logo_m_img">
					<img src="../../assets/img/1.png" alt="">
				</div>-->
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<div class="loginindex">
					<el-row>
						<el-col :span="6" :offset="17">
							<div class="login-form">
								<div>
									<div class="title">注 册</div>
								</div>
								<!-- <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="input3">
								</el-input> -->
								<el-form :model="formData" ref="formData" :rules="rules">
									<div class="input">
										<el-input v-model="formData.mobile" style="width:70%;height: 40px;" placeholder="请输入您的手机号码">
										</el-input>
									</div>
									 <div class="input">
										<el-input v-model="formData.linkman" style="width:70%;height: 40px;" placeholder="请输入联系人
										">
										</el-input>
									</div> 
									<div class="input">
										<el-input v-model="formData.password" type="password" style="width:70% ;height: 40px;" placeholder="请输入密码">
										</el-input>
									</div>
									<div class="input">
										<el-input v-model="formData.password_again" type="password" style="width:70% ;height: 40px;" placeholder="请再次输入密码">
										</el-input>
									</div>
									<div class="input">
										<el-input class="verification" v-model="formData.verify_code" style="width:70% ;height: 40px;" placeholder="请输入图形验证码">
											<template #append>
												<img @click="send_roundnum" :src="this.$axios.defaults.baseURL+'/api/yunsys.website/getcaptcha?roundnum='+roundnum" alt="">
											</template>
										</el-input>
									</div>
									<div class="input" :style="{'--append-bg-color':count_down?'#dcdfe6':'#ff8a5c','--append-font-color':count_down?'#000':'#fff'}">
										<el-input v-model="formData.phone_verification" style="width:70% ;height: 40px;" placeholder="请输入手机验证码">
											<template #append>
												<el-button  :color="count_down?count_down+'':'#ff8a5c'" :disabled="this.count_down>0" @click="send_verification">{{this.count_down?this.count_down+'秒':'发送'}}</el-button>
											</template>
										</el-input>
									</div>
								</el-form>
								
								<div class="input">
									<el-button style="width:70%;height: 40px;background: #ff8a5c;color:#fff" round @click="add" :loading="loading">注 册</el-button>
								</div>
								<div style="margin-top:5px;text-align:center;font-size:12px">
									<span>
								
										<el-checkbox v-model="checked1" label="Option 1" size="large" >
											<template #default>
												<span>
													我已阅读并同意
												</span>
												<span style="color:red">
													<el-link type="danger" underline="hover" @click.stop.prevent="agreementUser('/agreementUser')" >《用户协议》</el-link>
												</span>
												<span>|</span>
												<span style="color:red">
													<el-link type="danger" underline="hover" @click.stop.prevent="agreementUser('/agreementPrivacy')" >《隐私政策》</el-link>
												</span>
											</template>
										</el-checkbox>
									</span>
									
								</div>
								<div class="input bottom" >
									<el-row>
										<el-col :span="12" >
											<el-link type="primary" @click="$router.push('/forgetPassword')">忘记密码</el-link>
										</el-col>
										<el-col :span="12" style="color: #ff8a5c;">
											<el-link type="primary" @click="$router.push('/login')">去登录</el-link>
											
										</el-col>
									</el-row> 
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-col>
		</el-row>
		<el-row class="logo_m">
			<el-col :span="24">
				<div>
					CopyRight © 脱手网 2018 苏ICP备18008659号
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import '../../assets/login/index.css' //优化表格样式
import { ElMessage } from 'element-plus'
import HeadIndex from '../public/HeadIndex';
export default {
	name: 'register',
	components: {
		HeadIndex,
	},
	data() {

		return {
			appendBgColor:'',
			checked1:false,
			roundnum:'',
			count_down: 0,
			loading: false,
			formData: {
				linkman: '',
				password: '',
				mobile: '',
				password_again: '',
			},
			rules: {
				mobile: [{
					required: true,
					message: '请输入手机号！',
					trigger: 'blur'
				}],
				linkman: [{
					required: true,
					message: '请输入联系人！',
					trigger: 'blur'
				}],
				password: [{
					required: true,
					message: '请输入密码！',
					trigger: 'blur'
				}],
				password_again: [{
					required: true,
					message: '请再次输入密码！',
					trigger: 'blur'
				}],
			},
		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {
		this.send_roundnum()
	},
	watch: {

	},
	methods: {
		agreementUser(url){
			const newUrl = this.$router.resolve({ path: url}).href;
			window.open(newUrl, '_blank');
		},
		send_roundnum() {
			this.roundnum= new Date().getTime().toString()+Math.floor(Math.random() * 10000) + 1;
		},
		async send_verification() {
			//手动验证
			if (!this.checked1) {
				return ElMessage({
						message: '请阅读并同意《用户协议》《隐私政策》！',
						type: 'error',
						grouping: true // 开启合并功能
					})
			}
			
			if (!this.formData.linkman) {
				return ElMessage({
					message: '请填写联系人！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			if (!this.$validator.maxLength(this.formData.password)) {
				return ElMessage({
					message: '请填写6-16字符的密码！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			if (this.formData.password_again != this.formData.password) {
				return ElMessage({
					message: '请填写两次相同的密码！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			if (!this.formData.verify_code) {
				return ElMessage({
					message: '请填写图形验证码！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			if (!this.$validator.phone(this.formData.mobile)) {
				return ElMessage({
					message: '请填写正确的手机号！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			if (!this.formData.verify_code) {
				return ElMessage({
					message: '请填写图形验证码！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			await this.$axios.post('/api/yunsys.website/code', {mobile:this.formData.mobile,verify_code:this.formData.verify_code,roundnum:this.roundnum}).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					let countdownNumber = 60; // 倒计时时长，例如10秒
					var obj = this;
					const countdown = () => {
						if (countdownNumber > 0) {
							console.log(countdownNumber);
							countdownNumber--;
							obj.count_down = countdownNumber;
							setTimeout(countdown, 1000); // 每秒减少1
						} else {
							console.log('倒计时结束！');
						}
					};

					countdown(); // 开始倒计时
					ElMessage({
						message: res.msg,
						type: 'success',
						duration: 2000,
						grouping: true, // 开启合并功能
						
					})
				})
				.catch(err => {
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
			

		},

		async add() {
			if (!this.checked1) {
				return ElMessage({
						message: '请阅读并同意《用户协议》《隐私政策》！',
						type: 'error',
						grouping: true // 开启合并功能
					})
			}
			//手动验证
			if (!this.$validator.phone(this.formData.mobile)) {
				return ElMessage({
					message: '请填写正确的手机号！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			
			if (!this.formData.linkman) {
				return ElMessage({
					message: '请填写联系人！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			if (!this.$validator.maxLength(this.formData.password)) {
				return ElMessage({
					message: '请填写6-16字符的密码！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			if (this.formData.password_again != this.formData.password) {
				return ElMessage({
					message: '请填写两次相同的密码！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			if (!this.formData.verify_code) {
				return ElMessage({
					message: '请填写图形验证码！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			if (!this.formData.phone_verification) {
				return ElMessage({
					message: '请填写手机验证码！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			this.loading = true
			this.formData.roundnum=this.roundnum
			await this.$axios.post('/api/yunsys.Website/reg', this.formData).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					var obj = this;
					return ElMessage({
						message: res.msg,
						type: 'success',
						duration: 2000,
						grouping: true, // 开启合并功能
						onClose: function(v) {
							obj.$router.push('/login')
						}
					})
				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		}
	}
}
</script>
<style lang="less" scoped>
.login-form {
	margin: 10px 0;

}

.login-form .title {

	padding-top: 1.5rem;
}

.login-form .input {
	margin-top: 1rem;
}

.verification img {
	width: 100%;
	height: 40px;

}

:deep(.verification .el-input-group__append) {
	padding: 0px
}
:deep(.el-input-group__append, .el-input-group__prepend) {
  background-color: var(--append-bg-color); /* 使用 CSS 变量 */
  color:var(--append-font-color);
}

</style>